import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
import defaults from './hermesPage/default/main.vue'
const routes = [
  {
    path: '/:pathMatch(.*)*',
    name: 'default',
    component: defaults
  }
]

const router = new Router({
  base: '/web-10ce41t',
  mode: 'history',
  routes,
  scrollBehavior() {
    return {
      x: 0, y: 0
    }
  }
})

export default router
